export const API_BASE = import.meta.env.VITE_API_URL ?? '/api';

/** Esittelyversio hylkäsi tallennuksen: ilmoitus näytetään yhdessä paikassa (DemoBar). */
export const DEMO_READONLY_EVENT = 'vm-demo-readonly';

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message?: string,
  ) {
    super(message ?? code);
    // Esittelyversio hylkäsi tallennuksen (myös tiedostojen lataukset): yksi yhteinen ilmoitus.
    if (code === 'demo_readonly') window.dispatchEvent(new Event(DEMO_READONLY_EVENT));
  }
}

interface RequestOptions {
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body?: unknown;
}

/**
 * Kaikki kutsut backendiin. Istuntoeväste kulkee automaattisesti (credentials: include),
 * ja selain lisää Origin-otsakkeen, jonka backend tarkistaa.
 */
export async function api<T>(
  path: string,
  { method = 'GET', body }: RequestOptions = {},
): Promise<T> {
  const response = await fetch(API_BASE + path, {
    method,
    credentials: 'include',
    headers: body === undefined ? undefined : { 'content-type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (response.status === 204) return undefined as T;
  const data = (await response.json().catch(() => null)) as {
    error?: string;
    message?: string;
  } | null;
  if (!response.ok) {
    throw new ApiError(response.status, data?.error ?? 'server_error', data?.message);
  }
  return data as T;
}

/** Virhekoodi käännösavaimeksi. */
export function errorKey(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 429) return 'errors.rateLimited';
    if (error.code === 'seed_missing') return 'errors.seedMissing';
    if (error.code === 'demo_readonly') return 'errors.demoReadonly';
  }
  return 'errors.generic';
}
